module.exports = __webpack_public_path__ + "img/安全保障-bg.09cc670d.jpg";